import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { isEmpty, reduce, size } from 'lodash';
import { MarketingCheckbox, MarketingAdditionalInfo } from './components';
import { Box } from '../../../../common/components/index';
import './Marketing.scss';
import { FormGroup, Col } from 'react-bootstrap';
import MdEmail from 'react-icons/lib/md/email';
import MdPhoneIphone from 'react-icons/lib/md/phone-iphone';
import MdLaptopMac from 'react-icons/lib/md/laptop-mac';
import MdPhone from 'react-icons/lib/md/phone';

const Marketing = ({
  handleMarketingOptionsChange,
  name,
  showText,
  isMarketingEnabled,
  isInsuranceMarketingOptionsEnabled,
  marketingOptions,
  isHomeInsuranceMarketingEnabled,
  isCarInsuranceMarketingEnabled,
  isCustomerEditPage = false,
}) => {
  const selectAll = (e) => {
    const selected = e.currentTarget.checked ? 1 : -1;
    const marketingOptions = {
      post: selected,
      sms: selected,
      email: selected,
      phone: selected,
    };
    handleMarketingOptionsChange(marketingOptions);
  };

  useEffect(() => {
    if (!marketingOptions || marketingOptions.length === 0) {
      handleMarketingOptionsChange({
        email: -1,
        post: -1,
        phone: -1,
        sms: -1,
      });
    }
  }, []);

  const email = [{ label: 'Send Email?', value: 1, valid: [1, 2] }];
  const sms = [{ label: 'Send sms?', value: 1, valid: [1, 2] }];
  const post = [{ label: 'Send post?', value: 1, valid: [1, 2] }];
  const phone = [{ label: 'Send phone?', value: 1, valid: [1, 2] }];
  const marketingOptionsSet = marketingOptions && !isEmpty(marketingOptions);

  const consentToInt = (v) => {
    return v ? 1 : -1;
  };

  const consentToBool = (v) => {
    return v === 1 || v === 2;
  };
  const selectedAll = () =>
    size(marketingOptions) === 4 &&
    reduce(
      marketingOptions,
      (carry, option) => {
        return carry && option > 0;
      },
      true,
    );
  if (!isMarketingEnabled && !isInsuranceMarketingOptionsEnabled) {
    return null;
  }
  return (
    <Box className="marketing">
      {isMarketingEnabled && (
        <>
          <FormGroup>
            <Col sm={12}>
              <h4>Marketing</h4>
              {showText && (
                <span>
                  We’d like to keep in touch and send you details of special offers that
                  can be used on future policies and related products, as well as updates
                  on the latest travel news that may affect your plans.
                </span>
              )}
            </Col>
          </FormGroup>
          <FormGroup>
            <Col sm={4}>
              <Field
                name={'.selectAll'}
                component={MarketingCheckbox}
                checked={marketingOptionsSet ? selectedAll() : false}
                onChange={selectAll}
                labelSize={8}
                label="Select All"
                options={post}
              />
            </Col>
            <Col sm={4}>
              <Field
                name={name + '.post'}
                component={MarketingCheckbox}
                format={consentToBool}
                normalize={consentToInt}
                options={post}
                labelSize={8}
                label={
                  <div>
                    <MdEmail size={25} />
                    <span> Post</span>
                  </div>
                }
              />
            </Col>
            <Col sm={4}>
              <Field
                name={name + '.email'}
                component={MarketingCheckbox}
                format={consentToBool}
                normalize={consentToInt}
                options={email}
                labelSize={8}
                label={
                  <div>
                    <MdLaptopMac size={25} />
                    <span> Email</span>
                  </div>
                }
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={4} smOffset={4}>
              <Field
                name={name + '.sms'}
                component={MarketingCheckbox}
                format={consentToBool}
                normalize={consentToInt}
                options={sms}
                labelSize={8}
                label={
                  <div>
                    <MdPhoneIphone size={25} />
                    <span> SMS</span>
                  </div>
                }
              />
            </Col>
            <Col sm={4}>
              <Field
                name={name + '.phone'}
                component={MarketingCheckbox}
                format={consentToBool}
                normalize={consentToInt}
                options={phone}
                labelSize={8}
                label={
                  <div className="">
                    <MdPhone size={25} />
                    <span> Phone</span>
                  </div>
                }
              />
            </Col>
          </FormGroup>
        </>
      )}
      {isInsuranceMarketingOptionsEnabled && (
        <MarketingAdditionalInfo
          isCustomerEditPage={isCustomerEditPage}
          isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
          isHomeInsuranceMarketingEnabled={isHomeInsuranceMarketingEnabled}
        />
      )}
    </Box>
  );
};
export default Marketing;
